export type BillingPaymentMethodReference = {
  paymentMethodId?: string | null;
  paymentMethodTypeId?: string | null;
  paymentMethodKind?: "MANUAL" | "TOKENIZED" | null;
  paymentMethodDisplayName?: string | null;
};

const absent = (value: unknown) => value === undefined || value === null;
const text = (value: unknown, max: number): value is string => typeof value === "string" && value.trim().length > 0 && value === value.trim() && value.length <= max && !/[\u0000-\u001f\u007f-\u009f]/.test(value);

/** Missing historical evidence stays unknown; a method type alone is not a stored method. */
export function validBillingPaymentMethod(value: BillingPaymentMethodReference, required = false): boolean {
  if (absent(value.paymentMethodId)) return !required && [value.paymentMethodTypeId, value.paymentMethodKind, value.paymentMethodDisplayName].every(absent);
  return text(value.paymentMethodId, 500) && text(value.paymentMethodTypeId, 100) &&
    ["MANUAL", "TOKENIZED"].includes(value.paymentMethodKind || "") &&
    (text(value.paymentMethodDisplayName, 200) || !required && absent(value.paymentMethodDisplayName));
}

export function billingPaymentMethodLabel(value: BillingPaymentMethodReference, w: (ar: string, en: string) => string): string {
  if (!value.paymentMethodId) return w("غير موثقة في السجل السابق", "Not documented in the historical record");
  if (value.paymentMethodKind === "MANUAL" && value.paymentMethodTypeId === "EXT_OFFLINE" && value.paymentMethodDisplayName === "Local simulated payment") return w("سداد تجريبي محلي", "Local simulated payment");
  return value.paymentMethodDisplayName || (value.paymentMethodKind === "MANUAL" ? w("طريقة دفع يدوية", "Manual payment method") : w("طريقة دفع مرمّزة", "Tokenized payment method"));
}
